import axios from 'axios';
import { loadAbort } from 'utilities';

const nexusURL = import.meta.env.VITE_APP_NEXUS_URL;

export const getCoachesInput = () => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${nexusURL}/profiles/input`, {
        signal: controller.signal,
        params: { kind: 'Coach' },
      }),
    controller,
  };
};

export const getCoachGuestsInput = () => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${nexusURL}/profiles/input`, {
        signal: controller.signal,
        params: { kind: 'CoachGuest' },
      }),
    controller,
  };
};

export const getCoacheesInput = () => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${nexusURL}/profiles/input`, {
        signal: controller.signal,
        params: { kind: 'Coachee' },
      }),
    controller,
  };
};

export const getCompaniesInput = () => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${nexusURL}/companies/input`, {
        signal: controller.signal,
      }),
    controller,
  };
};
